import { render, staticRenderFns } from "./RealTimeStats.vue?vue&type=template&id=46e21afd&scoped=true"
import script from "./RealTimeStats.vue?vue&type=script&lang=js"
export * from "./RealTimeStats.vue?vue&type=script&lang=js"
import style0 from "./RealTimeStats.vue?vue&type=style&index=0&id=46e21afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e21afd",
  null
  
)

export default component.exports